{
  "loadingProperties": "Laster eiendommer...",
  "shareCapitalExceedsAvailable": "Andelskapital til overføring overstiger tilgjengelig beløp",
  "additionalCapitalExceedsAvailable": "Tilleggskapital til overføring overstiger tilgjengelig beløp",
  "valueTooHigh": "For høy verdi",
  "shareCapital": "Andelskapital",
  "additionalCapital": "Tilleggskapital",
  "paidShareCapital": "Innbetalt andelskapital",
  "deductionOutstandingInvoices": "Fradrag for utestående fakturaer",
  "shareCapitalThatCanBeTransferred": "Andelskapital som kan overføres",
  "typeCapital": "Type kapital",
  "type": "Type",
  "valueNok": "Saldo (NOK)",
  "totalAvailableShareCapitalForTransfer": "Total tilgjengelig andelskapital som kan overføres",
  "totalAvailableAdditionalCapitalForTransfer": "Total tilgjengelig tilleggskapital som kan overføres",
  "totalLabel": "Total",
  "totalRowLabel": "Totalt",
  "mainNumber": "Hovednummer",
  "area": "Areal (daa)",
  "areaPercentage": "Areal (%)",
  "shares": "Andeler",
  "sharesPercentage": "Andeler(%)",
  "calculatedShareCapitalPerProperty": "Beregnet andelskapital (NOK)",
  "paidCapital": "Innbetalt kapital (NOK)",
  "passedTo": "Overdras til",
  "transferredFromOwner": "Kapital til overføring (NOK)",
  "transferredFromOwnerTooltip": "Skriv inn hvor mye kapital som skal overføres til hver overtaker. Ved flere overtakere kan samlet beløp ikke overstige tilgjengelig total per kapitaltype.",
  "receiverCapitalCardDescription": "Overføre hele eller deler av andelskapital og tilleggskapitalen",
  "capitalSummaryTitle": "Oppsummering av kapitalfordeling",
  "capitalSummaryDescription": "Se hvor mye andelskapital og tilleggskapital som overføres til nye eiere, og hvor mye som blir stående igjen på sluttstykket",
  "totalShareCapitalToTransfer": "Total andelskapital til overføring",
  "totalAdditionalCapitalToTransfer": "Total tilleggskapital til overføring",
  "remainingShareCapitalText": "Gjenstående andelskapital",
  "remainingAdditionalCapitalText": "Gjenstående tilleggskapital",
  "summary": "Oppsummering",
  "summaryDescription": "Se over at informasjonen stemmer før du går videre",
  "summaryDistribution": "Oppsummert fordeling",
  "edit": "Endre",
  "allocatedShareCapital": "Tildelt andelskapital",
  "allocatedAdditionalCapital": "Tildelt tilleggskapital",
  "totalAllocatedCapital": "Totalt tildelt kapital",
  "remainingCapital": "Gjenværende kapital",
  "forestOwnerLabel": "skogeier",
  "capitalPaymentTitle": "Utbetaling av andelskapital",
  "updatedRequiredShareCapital": "Oppdatert pliktig andelskapital",
  "totalRequiredShareCapital": "Totalt pliktig andelskapital",
  "owedShareCapital": "Skyldig andelskapital",
  "owedShareCapitalDescription": "Trekkes automatisk ved fremtidige tømmeroppgjør",
  "remainingCapitalTitle": "Gjenstående kapital",
  "remainingCapitalDescription": "Gjenstående andelskapital og tilleggskapital etter overdragelse av eiendom(mer)",
  "changeShareOwnership": "Endre andelseierskap",
  "limitedAccessTitle": "Begrenset tilgang",
  "limitedAccessDescription": "Du har ikke tilgang til å endre andelseierskap. På denne siden kan du kun endre skogeierlag. Øvrige valg krever utvidet tilgang og er derfor deaktivert.",
  "loading": "Laster...",
  "alreadyAdded": "(Lagt til)",
  "atLeastOneReceiverRequired": "Du må legge til minst én overtaker for å fortsette",
  "searchNameOrBirthday": "Søk på navn eller fødselsdato",
  "noForestownersFound": "ingen skogeiere funnet",
  "noForestownersAdded": "Ingen skogeiere lagt til",
  "transferForm": "Overdragelsesskjema",
  "uploadTransferForm": "Last opp overdragelsesskjema",
  "paymentShareCapital": "Utbetaling av andelskapital",
  "receivers": "Overtaker(e)",
  "addRecipient": "Legg til overtaker(e)",
  "addRecipientSingle": "Legg til overtaker",
  "receiversDescription": "Legg til en eller flere overtakere og last opp overdragelsesskjema for hver av dem.",
  "receiversDescriptionSingle": "Legg til overtakeren og last opp overdragelsesskjema.",
  "addForestowners": "Legg til skogeiere som skal overta andelseierskapet",
  "addForestownersSingle": "Legg til skogeier som skal overta andelseierskapet",
  "transferShareOwnership": "Overdra andelseierskap",
  "estateSettlement": "Booppgjør",
  "estateSettlementDescription": "Andelseier er konkurs eller død",
  "shareCapitalBreakdown": "Regnestykke for gjenstående andelskapital",
  "totalPaidShareCapitalAndAdditionalCapitalToBePaid": "Total innbetalt andelskapital + tilleggskapital til utbetaling",
  "shareCapitalToPayment": "Andelskapital til utbetaling",
  "paymentShareCapitalDescription": "Resterende andelskapital vil utbetales etter neste årsmøte. Hvis summen overstiger 40 000,- vil det utbetales maks 40 000,- per år til det totale beløpet er utbetalt.",
  "paymentShareCapitalEstateSettlement": "Utbetaling av andelskapital ved booppgjør",
  "paymentShareCapitalEstateSettlementDescription": "Ved booppgjør vil hele andelskapitalen utbetales etter neste årsmøte",
  "productiveArea": "Produktivt areal (daa)",
  "bonitet": "Bonitet",
  "eierskap": "Eierskap",
  "ownershipPercentage": "Eierskap (%)",
  "mandatoryShareCapital": "Pliktig andelskapital",
  "mandatoryShareCapitalDescription": "Minimumskrav for andelskapital",
  "paidShareCapitalDescription": "Beløp som er innbetalt",
  "overviewCapitalConsequences": "Oversikt over kapitalkonsekvensjoner",
  "overviewNewShareOwnership": "Oversikt over nytt andelseierskap",
  "partnerRemoveConsequencesStepTitle": "Kapitalkonsekvensjoner",
  "partnerRemoveConsequencesStepDescription": "Se konsekvensene for både det nye medlemmet og det gjenværende medlemmet etter at partner blir fjernet.",
  "partnerAddTitle": "Legg til partner",
  "partnerAddCardTitle": "Partner",
  "partnerAddStepDescription": "Partner må være registrert hos Viken Skog for å kunne legges til.",
  "partnerAddSearchDescription": "Søk på navn eller fødselsdato",
  "partnerRemoveTitle": "Fordel andelskapital og fjern partner",
  "partnerRemoveCardTitle": "Fjern partner",
  "partnerRemoveSummaryStepTitle": "Oppsummering",
  "partnerRemoveStepDescription": "Fyll inn informasjon om partneren for å fjerne partneren fra andelseierskapet.",
  "partnerRemoveCapitalStepTitle": "Fordel kapital",
  "partnerRemoveCapitalStepDescription": "Fordel andelskapital og tilleggskapital mellom partneren som fjernes og gjenværende andelseier.",
  "partnerRemoveCapitalSummaryDescription": "Se hvor mye andelskapital og tilleggskapital som overføres til partner, og hvor mye som blir stående igjen på sluttstykket",
  "partnerRemoveShareCapitalExceedsAvailable": "Fordelt andelskapital kan ikke overstige tilgjengelig andelskapital",
  "partnerRemoveAdditionalCapitalExceedsAvailable": "Fordelt tilleggskapital kan ikke overstige tilgjengelig tilleggskapital",
  "partnerRemove": {
    "step4": {
      "description": "Sjekk at informasjonen stemmer før du fullfører fjerningen av partneren.",
      "personalInformation": "Personlig informasjon",
      "propertyOverview": "Eiendomsoversikt",
      "ownershipChange": "Endring i andelseierskap",
      "newMember": "Ny andelseier",
      "caseDocumentUploadLater": "Lastes opp senere",
      "submit": "Fullfør og lag endringer",
      "capital": {
        "partnerMandatoryDescription": "Pliktig andelskapital",
        "transferredCapital": "Overført kapital",
        "transferredCapitalDescription": "Overført kapital fra tidligere partnerskap",
        "allocatedAdditionalCapitalDescription": "Tilleggskapital overført fra partner",
        "remainingShareCapitalDescription": "Gjenstående andelskapital etter overdragelse av partner sine eiendommer",
        "remainingAdditionalCapitalDescription": "Gjenstående tilleggskapital etter overdragelse av partner sine eiendommer",
        "capitalToTransfer": "Kapital til overføring",
        "capitalToTransferDescription": "Kapital til overføring til tidligere partner"
      }
    }
  },
  "partner": {
    "removeLabel": "Fjern",
    "goToForestOwner": "Gå til skogeier",
    "selfRemovalAlert": {
      "title": "Du kan ikke fjerne partner fra denne skogeierprofilen",
      "description": "{{currentForestOwnerName}} ble lagt til som partner av {{ownerWhoAddedPartnerName}}. Fjerning av partner må derfor gjøres fra {{ownerWhoAddedPartnerName}} sin skogeierprofil."
    },
    "step2": {
      "title": "Eiendom",
      "description": "Legg til alle eiendommene knyttet til partner ved å bruke hovednummeret til hver eiendom",
      "loadingText": "Laster partnerens eiendommer...",
      "backButtonLabel": "Tilbake",
      "nextButtonLabel": "Neste",
      "allPropertiesConfirmed": {
        "title": "Jeg har registrert alle eiendommene til partner",
        "description": "For å registrere partneren må vi ha registrert alle eiendommene som er knyttet til partneren."
      }
    },
    "step3": {
      "title": "Vernet areal",
      "description": "Legg inn vernet areal per eiendom, fordelt på høy, middels og lav bonitet",
      "backButtonLabel": "Tilbake",
      "nextButtonLabel": "Neste"
    },
    "step4": {
      "title": "Andelseierskap",
      "summary": {
        "obligatoryShareCapital": "Pliktig andelskapital",
        "paidShareCapital": "Innbetalt andelskapital",
        "owedShareCapital": "Skyldig andelskapital"
      },
      "table": {
        "mainNumber": "Hovednummer",
        "productiveArea": "Produktivt areal (daa)",
        "shares": "Andeler",
        "bonitet": "Bonitet",
        "ownership": "Eierskap",
        "owner": "Eier",
        "shareCapital": "Beregnet andelskapital (NOK)",
        "total": "Total",
        "bonitetHighAbbreviation": "H",
        "bonitetMediumAbbreviation": "M",
        "bonitetLowAbbreviation": "L",
        "ownershipStatus": {
          "sharedWithPartner": "Deles med partner",
          "mustBeDocumented": "Må dokumenteres"
        }
      }
    },
    "step5": {
      "title": "Oppsummering",
      "description": "Sjekk at informasjonen stemmer før du legger til partneren",
      "partner": {
        "title": "Partner",
        "name": "Navn",
        "ssn": "Fødselsnummer",
        "address": "Adresse"
      },
      "costs": {
        "title": "Endring i andelseierskap",
        "updatedServiceFee": "Oppdatert serviceavgift",
        "updatedServiceFeePlaceholder": "Ikke beregnet ennå",
        "noCostChange": "Ingen endring i kostnader",
        "obligatoryShareCapital": {
          "subtitle": "Oppdatert pliktig andelskapital"
        },
        "paidShareCapital": {
          "subtitle": "Andelskapital som er innbetalt per i dag"
        },
        "owedShareCapital": {
          "subtitle": "Trekkes automatisk ved fremtidige tømmeroppgjør"
        }
      },
      "edit": "Endre",
      "submit": "Legg til partner",
      "submit.partialSuccess.title": "Partner ble lagret, men vernede arealer ble ikke oppdatert",
      "submit.partialSuccess.description": "Partner- og medlemskapsdata er lagret. Vernet areal kunne ikke oppdateres for følgende eiendommer: {{properties}}. Du kan prøve igjen fra veiviseren.",
      "submit.partialSuccess.genericDescription": "Partner- og medlemskapsdata er lagret, men oppdatering av vernet areal mislyktes. Du kan prøve igjen fra veiviseren.",
      "noCostChange": {
        "description": "Sjekk at informasjonen stemmer før du legger til partneren",
        "submit": "Fullfør og legg til partner",
        "ownership": {
          "title": "Eiendom",
          "subtitle": "Eiendomsoversikt",
          "subtitleDescription": "Oversikten viser eiendommene til deg og din partner, med ny beregnet andelskapital",
          "total": "Totalt beregnet andelskapital"
        },
        "costsTitle": "Endring i andelseierskap",
        "alertTitle": "Ingen endring i pliktig andelskapital",
        "alertDescription": "Skogeier har allerede betalt inn maksbeløpet for pliktig andelskapital, og denne endringen medfører ingen nye innbetalinger"
      }
    }
  }
}
